import { useMutation } from '@apollo/client';
import { BULK_APPROVE_REJECT_ORDER_REQUEST } from '../queries/orders';
import { BulkApproveRejectOrderRequest, BulkApproveRejectOrderRequestVariables } from '../queries/types/BulkApproveRejectOrderRequest';

export const useBulkApproveRejectOrderRequest = () => {
  const [bulkApproveRejectOrderRequest, { loading, data, error }] = useMutation<
    BulkApproveRejectOrderRequest,
    BulkApproveRejectOrderRequestVariables
  >(BULK_APPROVE_REJECT_ORDER_REQUEST);

  return {
    bulkApproveRejectOrderRequest,
    isBulkApproveRejectLoading: loading,
    bulkApproveRejectResult: data?.bulkApproveRejectOrderRequest,
    bulkApproveRejectError: error,
  };
};
